import React from 'react';
import './App.css';
// import NewTodoList from './components/NewTodoList'
import Todo from './components/Todo';
function App() {
  return (
    <div className="App">
      {/* <NewTodoList /> */}
      <Todo />
    </div>
  );
}

export default App;
